import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ResourcesService } from '../services/resources.service';

export const resourceTopicGuard: CanActivateFn = (route) => {

  const resourcesService = inject(ResourcesService);
  const router = inject(Router);

  const topic = route.paramMap.get('topic');

  if (!topic) {
    return router.parseUrl('/not-found');
  }

  return resourcesService.isValidTopic(topic)
    ? true
    : router.parseUrl('/not-found');

};